var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c(
        "b-navbar",
        { staticClass: "navbar", attrs: { toggleable: "lg" } },
        [
          _c(
            "router-link",
            { attrs: { to: "/" } },
            [
              _c("b-navbar-brand", [
                _c("img", {
                  staticClass: "navbar-brand-img",
                  style: _vm.getLogoStyles,
                  attrs: { src: _vm.getLogo }
                })
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ctm-container" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "12", md: "12" } },
                [
                  _c("h3", { class: _vm.styleClasses }, [
                    _vm._v(_vm._s(_vm.getMetaTitle))
                  ]),
                  _vm._v(" "),
                  _c("router-view", { staticClass: "mt-4" })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8079176", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8079176","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/InternalReducedLayout.vue
// module id = 2041
// module chunks = 116